import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Icon from 'carbon-react/lib/components/icon';
import Typography from 'carbon-react/lib/components/typography';
import Box from 'carbon-react/lib/components/box';

import { Recurrence, RecurrenceEndType, RecurrenceWeekDay } from './types';
import { RepeatMessage, EndsMessage } from './schedule-summary-messages';

interface ScheduleSummaryProps {
  recurrence: Recurrence;
  recurrenceStartDate: Date;
  recurrenceRepeatValue: string;
  recurrenceEndType: RecurrenceEndType;
  occurancesValue: string;
  recurrenceEndDate: Date;
  recurrenceWeekDay: RecurrenceWeekDay;
  recurrenceMonthDay: string;
}

export const ScheduleSummary = ({
  recurrence,
  recurrenceStartDate,
  recurrenceRepeatValue,
  recurrenceEndType,
  occurancesValue,
  recurrenceEndDate,
  recurrenceWeekDay,
  recurrenceMonthDay
}: ScheduleSummaryProps) => {
  const intl = useIntl();

  const firstSendDate = intl.formatDate(recurrenceStartDate, {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  return (
    <div
      style={{
        marginTop: '16px',
        padding: '16px',
        border: '1px solid #CCD6DB',
        borderRadius: '8px',
        backgroundColor: '#fff'
      }}
    >
      <Box display="flex" alignItems="center">
        <Icon type="info" color="#0060A7" mr="8px" />
        <Typography fontWeight="700" color="#0060A7" mb="0">
          <FormattedMessage id="predict.schedule_summary" defaultMessage="Schedule summary" />
        </Typography>
      </Box>
      <ul style={{ margin: 0, paddingLeft: '48px', listStyleType: 'disc' }}>
        <li>
          <Box mb="2px" display="flex" alignItems="center">
            <Typography fontWeight="500" mb={0}>
              <FormattedMessage id="predict.first_send_on" defaultMessage="First send on:" />
            </Typography>
            <Typography mb={0} ml="4px">
              {firstSendDate}
            </Typography>
          </Box>
        </li>
        <li>
          <Box mb="2px" display="flex" alignItems="center">
            <Typography fontWeight="500" mb={0}>
              <FormattedMessage id="predict.repeat" defaultMessage="Repeat:" />
            </Typography>
            <Typography mb={0} ml="4px">
              <RepeatMessage
                recurrence={recurrence}
                repeatValue={recurrenceRepeatValue}
                weekDay={recurrenceWeekDay}
                monthDay={recurrenceMonthDay}
              />
            </Typography>
          </Box>
        </li>
        <li>
          <Box display="flex" alignItems="center">
            <Typography fontWeight="500" mb={0}>
              <FormattedMessage id="predict.ends" defaultMessage="Ends:" />
            </Typography>
            <Typography mb={0} ml="4px">
              <EndsMessage endType={recurrenceEndType} occurancesValue={occurancesValue} endDate={recurrenceEndDate} />
            </Typography>
          </Box>
        </li>
      </ul>
    </div>
  );
};
